import React from "react";
import Userdetail from "./userdetail";
import Passwordpage from "./passwordpage";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="foundation-all">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="algebra-foundation">
                <div className="row">
                  <div className="col-lg-6">
                    <p className="foundation-heading1">Profile</p>
                    <p className="foundation-heading2">Update your profile</p>
                  </div>
                  <div className="col-lg-6">
                    <button
                      className="management-bt"
                      onClick={() => navigate("/manage-plan")}
                    >
                      Manage subscription
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Userdetail />
      <Passwordpage />
    </>
  );
};

export default ProfilePage;
